export default "__VITE_ASSET__BRAaTX6m__"